exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".select-select-2IDIB97Xmwr{display:inline-block}.select-trigger-5vCNTdmMmwr{display:inline-block;-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}.select-html-select-67wwtIC7mwr{display:block;left:-99999px;opacity:0;position:absolute;pointer-events:none;z-index:-999}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"select": "select-select-2IDIB97Xmwr",
	"trigger": "select-trigger-5vCNTdmMmwr",
	"html-select": "select-html-select-67wwtIC7mwr",
	"htmlSelect": "select-html-select-67wwtIC7mwr"
};